<template>
    <b-modal
        body-class="p-0"
        cancel-disabled
        hide-footer
        id="payment-error-modal"
        title="">
        <div class="modal-body modal-body-lg pt-0">
            <empty-state
                statusIcon="error"
                title="Something went wrong with your payment"
            ></empty-state>
            <ul class="list-group text-danger" v-if="billingError">
                <li class="list-group-item justify-content-between flex-wrap flex-sm-nowrap" v-if="billingError.address">
                    Incorrect billing address
                    <button class="btn btn-success btn-sm" @click="fixBillingAddress()">Update billing address</button>
                </li>
                <li class="list-group-item justify-content-between flex-wrap flex-sm-nowrap" v-if="billingError.phoneNumber">
                    Incorrect phone number
                    <router-link to="/booking-new/checkout/location">
                        <button class="btn btn-success btn-sm" @click="fixPhoneNumber()">Update phone number</button>
                    </router-link>
                </li>
                <template v-if="!billingError.address && !billingError.bookingReference">
                    <li class="list-group-item justify-content-between flex-wrap flex-sm-nowrap" v-for="(error, index) in errors" :key="index">
                        {{ error }}
                        <button class="btn btn-success btn-sm" @click="fixPaymentDetails()">Retry payment</button>
                    </li>
                </template>
            </ul>
        </div>
    </b-modal>
</template>

<script>
    export default {
        props: {
            paymentMethod: {
                type: String,
                default: "billing-address-panel"
            },
            errors: {},
            billingError: {
                address:false,
                phoneNumber:false,
                bookingReference:false
            }
        },

        methods: {
            fixBillingAddress() {
                this.$bvModal.hide("payment-error-modal");
                this.$emit("scrollToElement", 'billing-address-panel');
            },

            fixPaymentDetails() {
                this.$bvModal.hide("payment-error-modal");
                this.$emit("scrollToElement", this.paymentMethod);
            },

            fixPhoneNumber() {
                this.$bvModal.hide("payment-error-modal");
            }
        }
    }
</script>

<style scoped>

</style>